import { createFileRoute, useParams } from "@tanstack/react-router";
import { NotesGrid } from "../components/NotesGrid";
import { useFolders } from "../api/hooks";

export const Route = createFileRoute("/folders/$id")({
  component: FolderRoute,
});

function FolderRoute() {
  const { id } = useParams({ from: "/folders/$id" });
  const foldersQ = useFolders();
  const folder = foldersQ.data?.find((f) => f.id === id);
  return (
    <NotesGrid
      title={folder?.name ?? "Folder"}
      filter={{ folder: id, archived: false, trashed: false }}
      folderId={id}
    />
  );
}
